/* eslint-disable */
import React, { useEffect, useState } from "react";
import api from "../apiConfig";
// import Accordion from '../components/Accordions/Accordion';
import styled from "@emotion/styled/macro";
import { InputWrapper, Label, StyledInput } from "../components/Forms/Form";
import { t } from "i18next";
import { Textarea } from "@dnb/eufemia";
import { StyledTextArea } from "../components/Forms/SettingsForm";
import Button from "../components/Buttons/Button";
import toast from "react-hot-toast";
import Loader from "../components/Loaders/Loader";
import { Center } from "./ParameterStore";
import { useDispatch, useSelector } from "react-redux";
import { setChanges } from "../features/changeSlice";
import { StyledJsonEditor } from "../components/TextEditors/StyledJsonEditor";

export default function Tools() {
  const [tools, setTools] = useState({});

  const [loading, setLoading] = useState(true);
  const currentTheme = useSelector((state) => state.theme.currentTheme);
  const dispatch = useDispatch();

  useEffect(() => {
    api
      .get("/tools")
      .then((res) => setTools(res.data))
      .finally(() => setLoading(false));
  }, []);

  const saveTools = async () => {
    api
      .post("/tools", tools)
      .then(() => toast.success(t("common.DataUpdated")))
      .catch(() => toast.error(t("common.ErrorData")))
      .finally(() => setLoading(false));
  };

  if (loading) {
    return (
      <Center>
        {" "}
        <Loader />
      </Center>
    );
  }

  return (
    <Wrapper>
      <LangWrapper>
        <Label>{t("common.Descriptions")}</Label>
        <Spacing12 />
        <StyledJsonEditor
          data={tools}
          maxWidth={10000}
          currentTheme={currentTheme}
          onUpdate={({ newData }) => {
            dispatch(setChanges(true));
            setTools(newData);
          }}
        />
        <Button onClick={saveTools}>{t("layout.Save")}</Button>
      </LangWrapper>
    </Wrapper>
  );
}

const Spacing12 = styled.div`
  height: 12px;
`;

const Wrapper = styled.div`
  display: flex;
  color: ${(props) => props.theme.color};
  width: 100%;
  flex-direction: row;
  padding: 1rem;
`;
const LangWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  gap: 0.5rem;
`;
